import { BRAND } from "@/lib/brand";
import { Phone, Mail, MapPin } from "lucide-react";
import LogoMark from "@/components/site/LogoMark";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-[color:var(--border-subtle)] bg-[color:var(--navy-900)]">
      <div className="pointer-events-none absolute -bottom-16 -left-6 select-none opacity-[0.05]">
        <div className="font-display font-black text-[160px] md:text-[260px] leading-none uppercase tracking-tighter text-white">
          The Way Forward
        </div>
      </div>

      <div className="relative px-6 md:px-12 lg:px-20 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <LogoMark size={56} />
            <div>
              <div className="font-display font-bold uppercase text-2xl leading-none">The Way Forward</div>
              <div className="eyebrow text-[10px] mt-1">.solutions</div>
            </div>
          </div>
          <p className="text-[color:var(--text-secondary)] max-w-md leading-relaxed">
            Premium mental health, recovery and life transformation support for men ready to lead themselves,
            their families and their communities forward.
          </p>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow mb-4">Contact Joel</div>
          <div className="space-y-3 text-[color:var(--text-primary)]">
            <div className="font-display text-xl uppercase tracking-tight">{BRAND.founder}</div>
            <div className="text-sm text-[color:var(--text-secondary)]">{BRAND.title}</div>
            {BRAND.phones.map((p) => (
              <a
                key={p}
                data-testid={`footer-phone-${p}`}
                href={`tel:${p.replace(/\D/g, "")}`}
                className="flex items-center gap-2 hover:text-[color:var(--gold-500)] transition-colors"
              >
                <Phone size={16} className="text-[color:var(--gold-500)]" /> {p}
              </a>
            ))}
            <a
              data-testid="footer-email"
              href={`mailto:${BRAND.email}`}
              className="flex items-center gap-2 hover:text-[color:var(--gold-500)] transition-colors break-all"
            >
              <Mail size={16} className="text-[color:var(--gold-500)]" /> {BRAND.email}
            </a>
            <div className="flex items-center gap-2 text-[color:var(--text-secondary)]">
              <MapPin size={16} className="text-[color:var(--gold-500)]" /> {BRAND.domain}
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-4">Crisis Support</div>
          <p className="text-sm text-[color:var(--text-secondary)] leading-relaxed">
            If you are in crisis, please call <span className="text-[color:var(--gold-500)] font-semibold">988</span> —
            Suicide &amp; Crisis Lifeline. You are not alone.
          </p>
        </div>
      </div>

      <div className="relative border-t border-[color:var(--border-subtle)] px-6 md:px-12 lg:px-20 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[color:var(--text-tertiary)]">
        <div>© {new Date().getFullYear()} The Way Forward.solutions · All rights reserved.</div>
        <div className="font-display uppercase tracking-[0.2em]">Walking forward in purpose.</div>
      </div>
    </footer>
  );
}
